import { createSelector } from 'reselect';
import { sortObjects } from '../../helpers/helpers';

export const getTags = state => state.tags;

export const getSortedTags = createSelector(
  [getTags],
  tags => sortObjects(Object.values(tags), 'name'),
);
